import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW"; 

export default function FechGetAllUserReservationOnline(page) {
 
  var url = "/reservation/get_user_online_reservation" + page;

  return FetchGetDataWithAuthNEW(url);
}